import { j as n, a as r } from "../../../../../emotion-react-jsx-runtime.browser.esm-CsRinUqv.js";
import c from "../../../../string-table.js";
import "@ionic/react";
import "../../../../../FeatureFlagProvider-DSFeeZ8R.js";
import "react";
import "../../../../../react-paginate-Lh5zQzpz.js";
import { Section as d } from "../Section/Section.js";
import "../../../LoadingInterstitial/LoadingInterstitial.js";
import "../../../../contexts/DesignSystemProvider/DesignSystemProvider.js";
import '../../../../../css/WorkExperience.css';const C = "_experienceContentList_zzmtn_1", T = "_experienceContentListItem_zzmtn_7", O = "_experienceContentDate_zzmtn_11", R = "_noExperience_zzmtn_16", L = "_experienceContent_zzmtn_1", i = {
  experienceContentList: C,
  experienceContentListItem: T,
  experienceContentDate: O,
  noExperience: R,
  experienceContent: L
};
function z(p) {
  const {
    editable: t,
    experiences: o
  } = p;
  return /* @__PURE__ */ n(d, {
    onEditClick: t != null && t.isEditable ? t.onEditWorkExperience : void 0,
    title: c("SUB_PROFILE_RELEVANT_WORK_EXPERIENCE_HEADER"),
    children: /* @__PURE__ */ n("div", {
      children: o && o.length > 0 ? /* @__PURE__ */ n("ul", {
        className: i.experienceContentList,
        children: o.map((e) => {
          const s = new Date(e.startDate), _ = new Date((e == null ? void 0 : e.endDate) || "");
          return /* @__PURE__ */ n("li", {
            className: i.experienceContentListItem,
            children: /* @__PURE__ */ r("div", {
              className: i.experienceContent,
              children: [/* @__PURE__ */ n("div", {
                className: i.experienceContentDate,
                children: /* @__PURE__ */ r("span", {
                  children: [`${s.getMonth() + 1}/${s.getFullYear()}`, `${e.endDate ? ` - ${_.getMonth() + 1}/${_.getFullYear()}` : " - Present"}`]
                })
              }), /* @__PURE__ */ r("div", {
                className: i.experienceContentInfo,
                children: [/* @__PURE__ */ r("div", {
                  children: [/* @__PURE__ */ n("span", {
                    style: {
                      fontWeight: "var(--swing-font-semibold)"
                    },
                    children: `${e.organization}`
                  }), /* @__PURE__ */ r("span", {
                    children: [", ", e.role]
                  })]
                }), /* @__PURE__ */ n("div", {
                  className: i.experienceContentRole,
                  style: {
                    fontStyle: "italic"
                  },
                  children: `${N[e.type]}, (${e.tags.map((a, E, m) => E !== 0 && E <= m.length - 1 ? ` ${l[a]}` : l[a])})`
                })]
              })]
            })
          }, e.id);
        })
      }) : /* @__PURE__ */ n("span", {
        className: i.noExperience,
        children: t != null && t.isEditable ? c("SUB_PROFILE_RELEVANT_WORK_EXPERIENCE_EDIT_EMPTY") : c("SUB_PROFILE_NO_INFORMATION")
      })
    })
  });
}
const l = {
  EXP_TAG_K_5: "K-5",
  EXP_TAG_ADULT: "Adult",
  EXP_TAG_PRE_K: "Pre-K",
  EXP_TAG_9_12: "9-12",
  EXP_TAG_6_8: "6-8"
}, N = {
  SUBSTITUTE_TEACHER: "Substitute Teacher",
  ADMINISTRATOR: "Administrator",
  CLASSROOM_LEAD: "Classroom Lead",
  SMALL_GROUP_INSTRUCTION: "Small Group Instruction",
  ONE_ON_ONE: "One on One",
  CLASSROOM_SUPPORT: "Classroom Support"
};
export {
  l as ExperienceTag,
  N as ExperienceType,
  z as WorkExperience
};
